import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Money from 'brandComponents/Money';
import {useBasket} from 'brandHooks';

import {IOrderDetailsPaymentProps} from './IOrderDetailsPayment';
import messages from './messages';

const OrderDetailsPayment = ({classNames, paymentInstrument, currency}: IOrderDetailsPaymentProps) => {
	const basket = useBasket();
	const intl = useIntl();
	const paymentCard = paymentInstrument?.getPaymentCard();
	const holder = paymentCard?.getHolder();
	const amount = paymentInstrument?.getAmount();
	const paymentMethodId = paymentInstrument?.getPaymentMethodId();

	const paymentName = useMemo(() => {
		const applicablePaymentMethods = basket?.applicablePaymentMethods;
		const paymentMethod = applicablePaymentMethods?.find(
			(applicablePaymentMethod) => applicablePaymentMethod.id === paymentMethodId,
		);

		return paymentMethod ? paymentMethod?.name : paymentMethodId?.replace(/_/g, ' ');
	}, [basket.applicablePaymentMethods]);

	if (!paymentInstrument) {
		return <></>;
	}

	return (
		<div className={cn(classNames, 'order-details__payment')}>
			<span>{paymentName}</span>
			{holder && (
				<div className="order-details__payment__summary">
					<span>{holder}</span>
					<span>
						{paymentCard?.getCardType()} {paymentCard?.getMaskedNumber()}
					</span>
					{paymentCard?.getExpirationMonth && (
						<span>
							{intl.formatMessage(messages.expires)} {paymentCard?.getExpirationMonth()}/
							{paymentCard?.getExpirationYear()}
						</span>
					)}
				</div>
			)}
			{amount && (
				<span>
					{intl.formatMessage(messages.amount)}
					<Money value={amount} currency={currency} showLocalizedPrices={false} />
				</span>
			)}
		</div>
	);
};

export default OrderDetailsPayment;
